"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UFOForm = void 0;
var core_1 = require("@material-ui/core");
var acid_components_1 = require("@michelin/acid-components");
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var FormField_1 = require("../Form/FormField");
var UFOVehicleDetailsFormContext_1 = require("./UFOVehicleDetailsFormContext");
var types_1 = require("./types");
var FormComponent = function (props, ref) {
    var onSubmit = props.onSubmit, onValidationFailed = props.onValidationFailed, readOnly = props.readOnly, mode = props.mode, onDirtyStateChanged = props.onDirtyStateChanged, getTireSize = props.getTireSize, getCustomTireSize = props.getCustomTireSize, hideDetails = props.hideDetails, optionalTireSizes = props.optionalTireSizes, defaultValues = props.defaultValues;
    var _a = UFOVehicleDetailsFormContext_1.useUFOVehicleDetailsFormContext(), values = _a.values, load = _a.load, loading = _a.loading;
    var t = react_i18next_1.useTranslation().t;
    // Remap the null or undefined to empty string
    if (defaultValues)
        Object.keys(defaultValues).forEach(function (key) { var _a; defaultValues[key] = (_a = defaultValues[key]) !== null && _a !== void 0 ? _a : ''; });
    var _b = react_hook_form_1.useForm({
        defaultValues: defaultValues,
        mode: 'onChange',
    }), register = _b.register, _c = _b.formState, errors = _c.errors, isDirty = _c.isDirty, handleSubmit = _b.handleSubmit, control = _b.control, reset = _b.reset, watch = _b.watch, setValue = _b.setValue;
    var tireSize = watch('tire_size_id');
    var speedRating = watch('speed_rating');
    var model = watch('model_id');
    var option = watch('option_id');
    var vin = watch('vin');
    var _d = react_1.useState(defaultValues), formData = _d[0], setFormData = _d[1];
    if (option === 'unknown' || model === 'unknown') {
        if (tireSize !== 'custom' && tireSize !== 'unknown') {
            setValue('tire_size_id', 'custom');
        }
    }
    if (model === 'unknown') {
        if (option && option !== 'unknown') {
            setValue('option_id', null);
        }
    }
    if (!tireSize && getCustomTireSize)
        setValue('tire_size_id', 'custom');
    var areUnknownValues = function () { return option === 'unknown' || model === 'unknown'; };
    var onValid = function (data) {
        var _a, _b, _c, _d;
        if (!readOnly && onSubmit) {
            var vehicle_1 = data;
            var fixedData = __assign(__assign({}, data), { custom_tire_size_id: Number(vehicle_1.speed_rating) || null, make_name: (_a = values.makes.find(function (v) { return v.value === vehicle_1.make_id; })) === null || _a === void 0 ? void 0 : _a.label, model_name: (_b = values.models.find(function (v) { return v.value === vehicle_1.model_id; })) === null || _b === void 0 ? void 0 : _b.label, tire_size_id: vehicle_1.model_id && vehicle_1.tire_size_id ? vehicle_1.tire_size_id : null, option_id: vehicle_1.model_id && vehicle_1.option_id ? vehicle_1.option_id : null, model_id: vehicle_1.model_id || null, option_name: vehicle_1.option_id && vehicle_1.model_id ? (_c = values.options.find(function (v) { return v.value === vehicle_1.option_id; })) === null || _c === void 0 ? void 0 : _c.label : null, tire_size_name: vehicle_1.tire_size_id ? (_d = values.tireSizes.find(function (v) { return v.value === vehicle_1.tire_size_id; })) === null || _d === void 0 ? void 0 : _d.label : null });
            if (vehicle_1.tire_size_id === 'unknown') {
                fixedData.tire_size_id = null;
                fixedData.custom_tire_size_id = null;
            }
            if (vehicle_1.model_id === 'unknown') {
                fixedData.model_id = null;
                fixedData.option_id = null;
            }
            if (vehicle_1.option_id === 'unknown') {
                fixedData.option_id = null;
            }
            onSubmit(fixedData);
            setFormData(fixedData);
        }
    };
    var onInvalid = function (err) {
        if (!readOnly && onValidationFailed) {
            onValidationFailed(err);
        }
    };
    react_1.useImperativeHandle(ref, function () { return ({
        submit: function () {
            handleSubmit(onValid, onInvalid).bind(this)();
        },
        reset: function () {
            reset(formData);
        },
    }); });
    react_1.useEffect(function () {
        if (getTireSize && tireSize) {
            getTireSize(tireSize);
        }
    }, [tireSize]);
    react_1.useEffect(function () {
        if (getCustomTireSize && speedRating) {
            getCustomTireSize(speedRating);
        }
    }, [speedRating]);
    react_1.useEffect(function () {
        if (onDirtyStateChanged) {
            onDirtyStateChanged(isDirty);
        }
    }, [isDirty]);
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(acid_components_1.Panel, { title: getCustomTireSize ? t('Search by Custom Tire Sizes') : t('Vehicle Information'), style: { marginBottom: 16 } },
                !getCustomTireSize && (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.UFOVehicleDetailsKey.year,
                                label: t('Year'),
                                options: values.years,
                                loading: loading.years,
                                helperText: t('Year is required'),
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[types_1.UFOVehicleDetailsKey.year], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.UFOVehicleDetailsKey.make,
                                label: t('Make'),
                                options: values.makes,
                                loading: loading.makes,
                                helperText: t('Make is required'),
                                dependencies: [types_1.UFOVehicleDetailsKey.year],
                                onDependenciesChanged: load.makes,
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[types_1.UFOVehicleDetailsKey.make], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.UFOVehicleDetailsKey.model,
                                label: t('Model'),
                                options: values.models,
                                loading: loading.models,
                                dependencies: [types_1.UFOVehicleDetailsKey.year, types_1.UFOVehicleDetailsKey.make],
                                onDependenciesChanged: load.models,
                                rules: {
                                    required: false,
                                },
                            }, error: !!errors[types_1.UFOVehicleDetailsKey.model], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.UFOVehicleDetailsKey.option,
                                label: t('Option'),
                                options: values.options,
                                loading: loading.options,
                                helperText: !optionalTireSizes ? t('Option is required') : '',
                                dependencies: [types_1.UFOVehicleDetailsKey.year, types_1.UFOVehicleDetailsKey.make, types_1.UFOVehicleDetailsKey.model],
                                onDependenciesChanged: load.options,
                                rules: {
                                    required: !optionalTireSizes,
                                },
                            }, error: !!errors[types_1.UFOVehicleDetailsKey.option], readOnly: readOnly || model === 'unknown', register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.UFOVehicleDetailsKey.tireSize,
                                label: t('Tire Size'),
                                options: values.tireSizes,
                                loading: loading.tireSizes,
                                helperText: !optionalTireSizes ? t('Tire Size is required') : '',
                                dependencies: areUnknownValues()
                                    ? [types_1.UFOVehicleDetailsKey.year, types_1.UFOVehicleDetailsKey.make]
                                    : [types_1.UFOVehicleDetailsKey.year, types_1.UFOVehicleDetailsKey.make, types_1.UFOVehicleDetailsKey.model, types_1.UFOVehicleDetailsKey.option],
                                onDependenciesChanged: areUnknownValues() ? load.loadOnlyCustomOptionTireSize : load.tireSizes,
                                rules: {
                                    required: !optionalTireSizes,
                                },
                            }, error: !!errors[types_1.UFOVehicleDetailsKey.tireSize], readOnly: readOnly, register: register, control: control })))),
                tireSize !== 'custom'
                    ? null
                    : (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                            react_1.default.createElement(FormField_1.FormField, { definition: {
                                    name: types_1.UFOVehicleDetailsKey.customTireSizeSize,
                                    label: t('Tire Size'),
                                    options: values.customTireSizeSizes,
                                    loading: loading.customTireSizeSizes,
                                    helperText: t('Custom Tire Size is required'),
                                    dependencies: [types_1.UFOVehicleDetailsKey.tireSize],
                                    onDependenciesChanged: load.customTireSizeSizes,
                                    rules: {
                                        required: tireSize === 'custom',
                                    },
                                }, error: !!errors[types_1.UFOVehicleDetailsKey.customTireSizeSize], readOnly: readOnly, register: register, control: control })),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                            react_1.default.createElement(FormField_1.FormField, { definition: {
                                    name: types_1.UFOVehicleDetailsKey.customTireSizeAspectRatio,
                                    label: t('Aspect Ratio'),
                                    options: values.customTireSizeAspectRatios,
                                    loading: loading.customTireSizeAspectRatios,
                                    helperText: t('Aspect Ratio is required'),
                                    dependencies: [types_1.UFOVehicleDetailsKey.tireSize, types_1.UFOVehicleDetailsKey.customTireSizeSize],
                                    onDependenciesChanged: load.customTireSizeAspectRatios,
                                    rules: {
                                        required: tireSize === 'custom',
                                    },
                                }, error: !!errors[types_1.UFOVehicleDetailsKey.customTireSizeAspectRatio], readOnly: readOnly, register: register, control: control })),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                            react_1.default.createElement(FormField_1.FormField, { definition: {
                                    name: types_1.UFOVehicleDetailsKey.customTireSizeDiameter,
                                    label: t('Diameter'),
                                    options: values.customTireSizeDiameters,
                                    loading: loading.customTireSizeDiameters,
                                    helperText: t('Diameter is required'),
                                    dependencies: [types_1.UFOVehicleDetailsKey.tireSize, types_1.UFOVehicleDetailsKey.customTireSizeSize, types_1.UFOVehicleDetailsKey.customTireSizeAspectRatio],
                                    onDependenciesChanged: load.customTireSizeDiameters,
                                    rules: {
                                        required: tireSize === 'custom',
                                    },
                                }, error: !!errors[types_1.UFOVehicleDetailsKey.customTireSizeDiameter], readOnly: readOnly, register: register, control: control })),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3 },
                            react_1.default.createElement(FormField_1.FormField, { definition: {
                                    name: types_1.UFOVehicleDetailsKey.customTireSizeLoad,
                                    label: t('Load'),
                                    options: values.customTireSizeLoads,
                                    loading: loading.customTireSizeLoads,
                                    helperText: t('Load is required'),
                                    // eslint-disable-next-line max-len
                                    dependencies: [types_1.UFOVehicleDetailsKey.tireSize, types_1.UFOVehicleDetailsKey.customTireSizeSize, types_1.UFOVehicleDetailsKey.customTireSizeAspectRatio, types_1.UFOVehicleDetailsKey.customTireSizeDiameter],
                                    onDependenciesChanged: load.customTireSizeLoads,
                                    rules: {
                                        required: tireSize === 'custom',
                                    },
                                }, error: !!errors[types_1.UFOVehicleDetailsKey.customTireSizeLoad], readOnly: readOnly, register: register, control: control })),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3 },
                            react_1.default.createElement(FormField_1.FormField, { definition: {
                                    name: types_1.UFOVehicleDetailsKey.customTireSizeSpeedRating,
                                    label: t('Speed Rating'),
                                    options: values.customTireSizeSpeedRatings,
                                    loading: loading.customTireSizeSpeedRatings,
                                    helperText: t('Speed Rating is required'),
                                    // eslint-disable-next-line max-len
                                    dependencies: [types_1.UFOVehicleDetailsKey.tireSize, types_1.UFOVehicleDetailsKey.customTireSizeSize, types_1.UFOVehicleDetailsKey.customTireSizeAspectRatio, types_1.UFOVehicleDetailsKey.customTireSizeDiameter, types_1.UFOVehicleDetailsKey.customTireSizeLoad],
                                    onDependenciesChanged: load.customTireSizeSpeedRatings,
                                    rules: {
                                        required: tireSize === 'custom',
                                    },
                                }, error: !!errors[types_1.UFOVehicleDetailsKey.customTireSizeSpeedRating], readOnly: readOnly, register: register, control: control })))))),
        !hideDetails && !getCustomTireSize && !getTireSize && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(acid_components_1.Panel, { title: t('Vehicle Details'), style: { marginBottom: 16 } },
                react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.UFOVehicleDetailsKey.vehicleUnitNumber,
                                label: t('Vehicle Unit Number'),
                                helperText: t('Vehicle Unit Number is required'),
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[types_1.UFOVehicleDetailsKey.vehicleUnitNumber], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, onBlur: function () { return setValue('vin', vin.toString().toLocaleUpperCase()); } },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.UFOVehicleDetailsKey.vin,
                                label: t('VIN'),
                                helperText: t('VIN is required and should be 17 characters long'),
                                rules: {
                                    required: true,
                                    minLength: 17,
                                    maxLength: 17,
                                },
                                forceUppercase: true,
                            }, error: !!errors[types_1.UFOVehicleDetailsKey.vin], readOnly: readOnly || mode === 'edit', register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.UFOVehicleDetailsKey.licensePlate,
                                label: t('License Plate Number'),
                                helperText: t('License Plate Number is required and should be 7 characters or shorter'),
                                rules: {
                                    required: true,
                                    maxLength: 7,
                                },
                            }, error: !!errors[types_1.UFOVehicleDetailsKey.licensePlate], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.UFOVehicleDetailsKey.licenseState,
                                label: t('License Plate State'),
                                helperText: t('License Plate State is required'),
                                options: values.states,
                                loading: loading.states,
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[types_1.UFOVehicleDetailsKey.licenseState], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 2 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.UFOVehicleDetailsKey.color,
                                label: t('Color'),
                                rules: {
                                    required: false,
                                },
                            }, error: !!errors[types_1.UFOVehicleDetailsKey.color], readOnly: readOnly, register: register, control: control }))))))));
};
var UFOForm = react_1.forwardRef(FormComponent);
exports.UFOForm = UFOForm;
//# sourceMappingURL=Form.js.map